import {useSelector} from 'react-redux'

import useEthicalWills from './useEthicalWills'
import {LIFE_STORY_DISMISS_FLAG} from '../lifeStoryTools'
import {currentUser} from '../../../../../../lib/userTools'

const useLifeStoryHero = ({userConfig, ownEverplan, skip = false}) => {
  const {loadingEthicalWills, ethicalWillsUnavailable, ethicalWills} = useEthicalWills({skip})
  const user = useSelector(state => currentUser({userConfig, users: state.api.users}))
  const dismissed = Boolean(user.getIn(['viewed-flags', LIFE_STORY_DISMISS_FLAG]))

  return {
    loading: loadingEthicalWills,
    visible: !loadingEthicalWills && !ethicalWillsUnavailable && Boolean(ownEverplan) && !dismissed,
    ethicalWills
  }
}

export default useLifeStoryHero
